import "./ServicedAreas.module.css";
import EnTTe from "@/reusable_sections/Header";
import ONousIntervenons from "./sections/ONousIntervenons";
import VillesEtQuartiers from "./sections/VillesEtQuartiers";
import DisponibilitLocale from "./sections/DisponibilitLocale";
import PiedDePage from "@/reusable_sections/Footer";
export default function ServicedAreasPage() {
  return <div>
      <EnTTe />
      <ONousIntervenons />
      <VillesEtQuartiers />
      <DisponibilitLocale />
      <PiedDePage />
    </div>;
}